// Currently hard-code, ideal this will be generated together with the API Clients

export const configuratiebeheerder = 'configuratiebeheerder';
export const dataleverancier = 'dataleverancier';
export const databeheerder = 'databeheerder';
export const systeembeheerder = 'systeembeheerder';
